//Styles
import myStyles from "../../../styles/housing/HousingAllocations.module.css"

//PrimeReact
import { Tooltip } from "primereact/tooltip"
import { getHouseImageUrl } from "../shared"
import { useMemo } from "react"

export function HouseSelection({
  houseObject,
  clickAction,
  selectedHouse,
  programs,
  isLoadingPrograms,
}) {
  const housePrograms = [
    ...new Set(
      programs
        .filter((program) =>
          houseObject.programs.some(
            (houseProgram) =>
              houseProgram.programId === program.program_identity_id,
          ),
        )
        .map((program) => program.program_id_name),
    ),
  ]

  const houseImageUrl = useMemo(
    () => getHouseImageUrl(houseObject.houseImageUrl),
    [houseObject.houseImageUrl],
  )

  let programToolTip = ""

  if (programs !== undefined && programs.length > 0) {
    programToolTip =
      housePrograms.length > 0
        ? `House programs: 
${housePrograms.join("\n")}`
        : "No programs allocated to this house"
  }

  return (
    <>
      <div
        className={`${myStyles.houseBlock} ${
          selectedHouse?.house.id === houseObject?.house.id
            ? myStyles.houseBlockSelected
            : ""
        } `}
        onClick={(y) => {
          clickAction(houseObject)
        }}
      >
        <Tooltip target=".hs-selection-t-tip" />
        <div className={myStyles.houseCardGridContainer}>
          <div className={myStyles.houseCardGridItemPhoto}>
            <img
              src={houseImageUrl}
              alt="HouseImage"
              className={myStyles.houseImage}
            />
          </div>
          <div className={myStyles.houseCardGridItemName}>
            {houseObject.house.name}
          </div>
          <div
            className={`${myStyles.houseCardGridItemPrograms} hs-selection-t-tip`}
            style={{
              color:
                programs === undefined ||
                programs.length === 0 ||
                housePrograms.length > 0
                  ? ""
                  : "red",
            }}
            data-pr-tooltip={programToolTip}
          >
            Programs: {isLoadingPrograms ? "Loading..." : null}
            {programs !== undefined && !isLoadingPrograms ? (
              <>
                {housePrograms.length}{" "}
                <span
                  className="material-icons top-icon-span"
                  style={{ fontSize: "15px", marginLeft: "10px" }}
                >
                  {"more"}
                </span>
              </>
            ) : null}
          </div>
          <div className={myStyles.houseCardGridItemAddress}>
            {houseObject.house.shortAddress}
          </div>
        </div>
      </div>
    </>
  )
}
